import React, { forwardRef } from 'react'
import { useTranslation } from "react-i18next"
 
export const PrintOrder = forwardRef(({ order }, ref) => {
  const { t } = useTranslation()
 
  return (
    <div ref={ref} className='printable text-center mt-3'>
        <div className='text-uppercase fs-4 fw-bolder'>{t('admin.orders.order')}</div>
        <div className='text-uppercase fs-3 fw-bolder'>{order?.orderReference}</div>
        <div className='text-uppercase fs-6 fw-bold'>{order?.user}</div><br/>
        <div className='text-uppercase fs-5 fw-bold'>{t('admin.menus.price')}: {order?.price} €</div>
        <strong>{t('admin.orders.restaurant')}: {order?.restaurant}</strong><br/><br/>
        <div className='text-uppercase fs-5 fw-bold'>
                {t('admin.orders.datehour')}<br/>
                {order?.date?.substr(8,2)}/{order?.orderAt?.substr(5,2)}/{order?.orderAt?.substr(0,4)} - {order?.hour}
        </div><br/>
        <div className='text-uppercase fs-6 fw-bold'>
                {t('admin.orders.datehourorder')}<br/>
                {order?.orderAt?.substr(8,2)}/{order?.orderAt?.substr(5,2)}/{order?.orderAt?.substr(0,4)} - {order?.orderAt?.substr(11,5)}
        </div><br/>
        <div>· {t('admin.orders.firstdish')}: <strong>{order?.firstdish?.name}</strong></div>
        <div>· {t('admin.orders.seconddish')}: <strong>{order?.seconddish?.name}</strong></div>
        <div>· {t('admin.orders.drink')}: <strong>{order?.drink?.name}</strong></div>
        <div>· {t('admin.orders.dessert')}: <strong>{order?.dessert?.name}</strong></div>
            {order?.complements?.length > 0 && (
        <>
        <strong>{t('admin.orders.complements')}</strong><br/>
                {order?.complements?.map((complement, index) => (
        <div key={index}>· <strong>{complement?.name}</strong></div>
                ))}
        </>
            )}
    </div>
  )
})